import React from "react";
import TutorPaperAccessList from "./components/TutorPaperAccessList";

export default function TutorMockExams() {
  return (
    <TutorPaperAccessList
      title="Mock Exams"
      endpoint="tutor/mock-exams"
      paperType="mock_exam"
      pdfUrl={(id) => `tutor/mock-exam/${id}/view-mock-exam-pdf`}
      showCategory
    />
  );
}
